import { defaultIconProps } from 'components/common/icons'
import type { DefaultIconProps } from 'components/common/icons'

export const HomeV2 = ({
  size = defaultIconProps.size,
  className = defaultIconProps.className,
  title = defaultIconProps.title,
}: DefaultIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg">
    {title && <title>{title}</title>}
    <path
      d="M3.99935 14.1668C3.53911 14.1668 3.16602 13.7937 3.16602 13.3335V9.16683C3.16602 8.70659 3.53911 8.3335 3.99935 8.3335C4.45959 8.3335 4.83268 8.70659 4.83268 9.16683V13.3335C4.83268 13.7937 4.45959 14.1668 3.99935 14.1668ZM8.99935 14.1668C8.53911 14.1668 8.16602 13.7937 8.16602 13.3335V9.16683C8.16602 8.70659 8.53911 8.3335 8.99935 8.3335C9.45959 8.3335 9.83268 8.70659 9.83268 9.16683V13.3335C9.83268 13.7937 9.45959 14.1668 8.99935 14.1668ZM1.49935 17.5002C1.03911 17.5002 0.666016 17.1271 0.666016 16.6668C0.666016 16.2066 1.03911 15.8335 1.49935 15.8335H16.4994C16.9596 15.8335 17.3327 16.2066 17.3327 16.6668C17.3327 17.1271 16.9596 17.5002 16.4993 17.5002H1.49935ZM13.9993 14.1668C13.5391 14.1668 13.166 13.7937 13.166 13.3335V9.16683C13.166 8.70659 13.5391 8.3335 13.9993 8.3335C14.4596 8.3335 14.8327 8.70659 14.8327 9.16683V13.3335C14.8327 13.7937 14.4596 14.1668 13.9993 14.1668ZM1.66601 6.66683C1.11373 6.66683 0.666016 6.21911 0.666016 5.66683V5.6182C0.666016 5.23942 0.880018 4.89316 1.2188 4.72377L8.55214 1.0571C8.83366 0.916339 9.16504 0.916339 9.44656 1.0571L16.7799 4.72377C17.1187 4.89316 17.3327 5.23942 17.3327 5.6182V5.66683C17.3327 6.21911 16.885 6.66683 16.3327 6.66683H1.66601Z"
      fill="#0D69C0"
    />
  </svg>
)
